import React from 'react';
import { useTranslation } from 'react-i18next';
import type { LeagueBookmakersListItem } from '@/types/leagueBookmakers';
import styles from '@/pages/admin/LeagueBookmakersTab.module.scss';

interface LeagueListItemProps {
  item: LeagueBookmakersListItem;
  isSelected: boolean;
  onSelect: (leagueId: number) => void;
}

export const LeagueListItem: React.FC<LeagueListItemProps> = ({ item, isSelected, onSelect }) => {
  const { t } = useTranslation('admin');
  const { league, bookmakers } = item;
  const hasMapping = bookmakers.length > 0;

  return (
    <button
      type="button"
      className={`${styles.leagueRow} ${isSelected ? styles.selected : ''}`}
      onClick={() => onSelect(league.id)}
    >
      {league.logoUrl && (
        <img src={league.logoUrl} alt="" className={styles.leagueLogo} loading="lazy" />
      )}
      <div className={styles.leagueInfo}>
        <span className={styles.leagueName}>{league.name}</span>
        <span className={styles.leagueMeta}>
          {league.country || ''}{league.season ? ` · ${league.season}` : ''}
        </span>
      </div>
      <span className={`${styles.leagueCount} ${hasMapping ? styles.mapped : ''}`}>
        {hasMapping
          ? t('leagueListCount', { count: bookmakers.length })
          : t('leagueListNoMapping')}
      </span>
    </button>
  );
};

export default LeagueListItem;
